export const SET_DELIVERY_FORM = 'SET_DELIVERY_FORM'
export const ADD_DELIVERY_FORM = 'ADD_DELIVERY_FORM'
export const REMOVE_DELIVERY_FORM = 'REMOVE_DELIVERY_FORM'